import React, { useEffect, useState } from "react";

export default function AttUserSchedule({ formData, isAdd, setFormData }) {
  /*   All States
   ********************************************* */

  const [weeklySchedule, setWeeklySchedule] = useState(
    Object.keys(formData?.weeklySchedule).length > 0
      ? formData?.weeklySchedule
      : {
          Monday: {
            inTime: isAdd ? "08:30" : "",
            outTime: isAdd ? "17:30" : "",
            working: isAdd ? true : false,
          },
          Tuesday: {
            inTime: isAdd ? "08:30" : "",
            outTime: isAdd ? "17:30" : "",
            working: isAdd ? true : false,
          },
          Wednesday: {
            inTime: isAdd ? "08:30" : "",
            outTime: isAdd ? "17:30" : "",
            working: isAdd ? true : false,
          },
          Thursday: {
            inTime: isAdd ? "08:30" : "",
            outTime: isAdd ? "17:30" : "",
            working: isAdd ? true : false,
          },
          Friday: {
            inTime: isAdd ? "08:30" : "",
            outTime: isAdd ? "17:30" : "",
            working: isAdd ? true : false,
          },
          Saturday: {
            inTime: isAdd ? "08:30" : "",
            outTime: isAdd ? "17:30" : "",
            working: isAdd ? true : false,
          },
          Sunday: {
            inTime: "",
            outTime: "",
            working: false,
          },
        }
  );

  const [rules, setRules] = useState(formData?.rules);

  /*   All Functions
   ********************************************* */
  const getPreviousDay = (dayName) => {
    const days = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];
    const index = days.indexOf(dayName);
    if (index === 0) {
      return null; // No previous day for Monday
    }
    return days[index - 1]; // Return the previous day
  };

  const copyPreviousDaysData = (dayName) => {
    // Copy the data from the previous day to the current day
    const previousDay = getPreviousDay(dayName);
    if (previousDay) {
      setWeeklySchedule((prev) => {
        return {
          ...prev,
          [dayName]: {
            ...prev[dayName],
            inTime: prev[previousDay].inTime,
            outTime: prev[previousDay].outTime,
            working: prev[previousDay].working,
          },
        };
      });
    }
  };

  const handleRuleChange = (e) => {
    const { name, checked } = e.target;
    setRules((prevRules) => ({
      ...prevRules,
      [name]: { ...prevRules[name], isChecked: checked },
    }));
  };

  /*   All UseEffects
   ********************************************* */

  useEffect(() => {
    setFormData((prev) => {
      return { ...prev, weeklySchedule: weeklySchedule };
    });
  }, [weeklySchedule]);

  useEffect(() => {
    setFormData((prev) => {
      return { ...prev, rules: rules };
    });
  }, [rules]);

  return (
    <div>
      <div className="card mb-4">
        <div className="card-header py-2 bg-light">
          <h4 className="">Schedule Settings</h4>
        </div>
        <div className="card-body">
          {/* Night Office Setting */}
          <div className="d-flex align-items-center mb-2">
            <label style={{ width: "25%" }}>Is Night Office User?</label>
            <div style={{ width: "75%" }}>
              <input
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    isNightOffice: e.target.checked,
                  })
                }
                checked={formData?.isNightOffice || ""}
                type="checkbox"
                id="switch0"
                data-switch="none"
              />
              <label
                htmlFor="switch0"
                data-on-label="Yes"
                data-off-label="No"
              ></label>
            </div>
          </div>
          <hr />

          {/* Group: Relaxation Minutes + Late Time Rule */}
          <div className="">
            {/* Relaxation Minutes */}
            <div className="d-flex align-items-start mb-2">
              <label style={{ width: "25%" }}>Relaxation Minutes</label>
              <div style={{ width: "75%" }}>
                <input
                  name={"relaxationMinutes"}
                  type="number"
                  max={60}
                  min={0}
                  placeholder={`Enter relaxation time in minutes`}
                  value={formData?.relaxationMinutes || ""}
                  onChange={(e) => {
                    setFormData((prev) => {
                      return {
                        ...prev,
                        relaxationMinutes: parseInt(e.target.value),
                      };
                    });
                  }}
                  className="form-control"
                />
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="lateTime"
                    name="lateTime"
                    onChange={handleRuleChange}
                    checked={rules.lateTime.isChecked}
                  />
                  <p className="form-text text-muted small mt-2">
                    {rules.lateTime.description}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Group: Overtime After Minutes + Overtime Rule */}
          <div className="">
            {/* Overtime After Minutes */}
            <div className="d-flex align-items-start ">
              <label style={{ width: "25%" }}>Overtime After Minutes</label>
              <div style={{ width: "75%" }}>
                <input
                  name={"overtimeAfterMinutes"}
                  type="number"
                  max={60}
                  min={0}
                  placeholder={`Enter Overtime After time in minutes`}
                  value={formData?.overtimeAfterMinutes || ""}
                  onChange={(e) => {
                    setFormData((prev) => {
                      return {
                        ...prev,
                        overtimeAfterMinutes: parseInt(e.target.value),
                      };
                    });
                  }}
                  className="form-control"
                />
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="overTime"
                    name="overTime"
                    onChange={handleRuleChange}
                    checked={rules.overTime.isChecked}
                  />
                  <p className="form-text text-muted small mt-2">
                    {rules.overTime.description}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header py-2 bg-light">
          <h4 className="">Weekly Schedule</h4>
        </div>
        <div className="card-body">
          <div className="d-flex align-items-center mb-3">
            <h5 style={{ width: "30%" }} className="text-nowrap mb-0">
              Week Name
            </h5>
            <h5 style={{ width: "30%" }} className="text-nowrap mb-0">
              In Time
            </h5>
            <h5 style={{ width: "30%" }} className="text-nowrap mb-0">
              Out Time
            </h5>
            <h5 style={{ width: "13%" }} className="text-center mb-0">
              Working
            </h5>
          </div>

          {weeklySchedule &&
            Object.keys(weeklySchedule)?.map((weekName, index) => (
              <div
                key={weekName}
                className="d-flex justify-content-between align-items-center mb-2"
              >
                <h5 style={{ width: "20%" }} className="mb-0">
                  {weekName}
                </h5>
                <div className="row" style={{ width: "40%" }}>
                  <div className="col-3 px-0 d-flex align-items-center justify-content-end">
                    {index !== 0 && (
                      <button
                        type="button"
                        onClick={(e) => {
                          copyPreviousDaysData(weekName);
                        }}
                        className="btn btn-sm btn-success px-1 py-0 me-1"
                        title="Copy from previous day"
                      >
                        C
                      </button>
                    )}
                  </div>
                  <div className="col-9 mx-0 px-0">
                    <input
                      value={weeklySchedule[weekName].inTime}
                      onChange={(e) => {
                        setWeeklySchedule((prev) => {
                          return {
                            ...prev,
                            [weekName]: {
                              ...prev[weekName],
                              inTime: e.target.value,
                            },
                          };
                        });
                      }}
                      type="time"
                      className="form-control"
                      id="inTime"
                    />
                  </div>
                </div>
                <div style={{ width: "30%" }}>
                  <input
                    value={weeklySchedule[weekName].outTime || ""}
                    onChange={(e) => {
                      setWeeklySchedule((prev) => {
                        return {
                          ...prev,
                          [weekName]: {
                            ...prev[weekName],
                            outTime: e.target.value,
                          },
                        };
                      });
                    }}
                    type="time"
                    className="form-control"
                    id="outTime"
                  />
                </div>

                <div style={{ width: "10%" }} className="text-center">
                  <input
                    checked={weeklySchedule[weekName].working}
                    onChange={(e) => {
                      setWeeklySchedule((prev) => {
                        return {
                          ...prev,
                          [weekName]: {
                            ...prev[weekName],
                            working: e.target.checked,
                          },
                        };
                      });
                    }}
                    type="checkbox"
                    className="form-check-input"
                    id={`working-${weekName}`}
                  />
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
